import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

type Props = {
    roles: string[]
}

const RequireRole = ({roles} : Props) => {
    const { auth } = useAuth();
    const location = useLocation();

  return (
    (auth.data)
      ? <>{
        roles.includes(auth?.data?.m_sRole) 
            ? <Outlet />
            : <Navigate to="/unauthorized" state={{ from: location }} replace />
        }</>
      : <Navigate to="/" state={{ from: location }} replace />
  )
}

export default RequireRole